import React, { memo, useMemo } from "react";
import {
  Button,
  Center,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { useDistributionGroups } from "modules/providers/distribution-groups-provider";
import { useTags } from "modules/providers/tags-provider";
import { CALLOUT_KEY } from "modules/utils/Constants";
import { HashIcon, GreenCheckIcon } from "modules/icons";
import colors from "app/colors";
import { useOverlay } from "modules/providers/overlay-provider";

interface IProps {
  distributionGroupId?: string;
}

const AdminDistributionGroupAddedModal = ({ distributionGroupId }: IProps) => {
  const { closeModal } = useOverlay();
  const { distributionGroupsById } = useDistributionGroups();
  const { tags } = useTags();

  const distributionGroup = useMemo(() => {
    if (distributionGroupId) {
      return distributionGroupsById[distributionGroupId];
    }
  }, [distributionGroupId, distributionGroupsById]);

  const tagList = useMemo(
    () => tags.filter((obj) => distributionGroup?.tagIdList.includes(obj.id)),
    [distributionGroup?.tagIdList, tags],
  );

  if (!distributionGroup) {
    return null;
  }

  return (
    <Modal isOpen onClose={closeModal} size="sm" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalBody>
          <VStack>
            <GreenCheckIcon boxSize={100} />
            <Center>
              <Text fontSize={20} fontWeight={700}>
                Group Created!
              </Text>
            </Center>
            <Center>
              <Text align="center">
                A new group {CALLOUT_KEY}
                {distributionGroup.name} has been created
                {tagList.length > 0 && <> with the tags:</>}
              </Text>
            </Center>
            {tagList.length > 0 && (
              <Wrap pt={2}>
                {tagList.map((tag) => (
                  <WrapItem key={tag.id}>
                    <HStack
                      spacing={1}
                      paddingX={2}
                      borderRadius={16}
                      borderWidth={1}
                      fontWeight={700}
                      fontSize={13}
                      borderColor={colors.grayPrimary}
                      color={colors.gray50}
                    >
                      <HashIcon boxSize="11px" fill={colors.gray50} />
                      <Text>{` ${tag.displayName}`}</Text>
                    </HStack>
                  </WrapItem>
                ))}
              </Wrap>
            )}
            <HStack>
              <Button variant="solid" height={8} onClick={closeModal}>
                Close
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(AdminDistributionGroupAddedModal);
